module.exports = __webpack_public_path__ + "img/50_27.085375f6.png";